export const limitedReleaseByVirtualConstants = {
  LIMITED_RELEASE_BY_VIRTUAL_LOADING: "LIMITED_RELEASE_BY_VIRTUAL_LOADING",
  LIMITED_RELEASE_BY_VIRTUAL_SUCCESS: "LIMITED_RELEASE_BY_VIRTUAL_SUCCESS",
  LIMITED_RELEASE_BY_VIRTUAL_FAILURE: "LIMITED_RELEASE_BY_VIRTUAL_FAILURE",
};

export const createLimitedReleaseByVirtualConstants = {
  CREATE_LIMITED_RELEASE_BY_VIRTUAL_LOADING:
    "CREATE_LIMITED_RELEASE_BY_VIRTUAL_LOADING",
  CREATE_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS:
    "CREATE_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS",
  CREATE_LIMITED_RELEASE_BY_VIRTUAL_FAILURE:
    "CREATE_LIMITED_RELEASE_BY_VIRTUAL_FAILURE",
};

export const editLimitedReleaseByVirtualConstants = {
  EDIT_LIMITED_RELEASE_BY_VIRTUAL_LOADING:
    "EDIT_LIMITED_RELEASE_BY_VIRTUAL_LOADING",
  EDIT_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS:
    "EDIT_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS",
  EDIT_LIMITED_RELEASE_BY_VIRTUAL_FAILURE:
    "EDIT_LIMITED_RELEASE_BY_VIRTUAL_FAILURE",
};

export const deleteLimitedReleaseByVirtualConstants = {
  DELETE_LIMITED_RELEASE_BY_VIRTUAL_LOADING:
    "DELETE_LIMITED_RELEASE_BY_VIRTUAL_LOADING",
  DELETE_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS:
    "DELETE_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS",
  DELETE_LIMITED_RELEASE_BY_VIRTUAL_FAILURE:
    "DELETE_LIMITED_RELEASE_BY_VIRTUAL_FAILURE",
};

export const activateLimitedReleaseByVirtualConstants = {
  ACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_LOADING:
    "ACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_LOADING",
  ACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS:
    "ACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS",
  ACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_FAILURE:
    "ACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_FAILURE",
};

export const deactivateLimitedReleaseByVirtualConstants = {
  DEACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_LOADING:
    "DEACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_LOADING",
  DEACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS:
    "DEACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_SUCCESS",
  DEACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_FAILURE:
    "DEACTIVATE_LIMITED_RELEASE_BY_VIRTUAL_FAILURE",
};
